const serverUrl = process.env.REACT_APP_SERVER_URL;

export const fetchProducts = () => {
  return async (dispatch) => {
    dispatch({ type: "FETCH_PRODUCTS_REQUEST" });
    try {
      const response = await fetch(`${serverUrl}/get-products`);
      const data = await response.json();
      // API may return an object like { success: true, products: [...] }
      // Normalize payload to always be an array of products when possible.
      const payload = Array.isArray(data)
        ? data
        : Array.isArray(data?.products)
          ? data.products
          : data;
      dispatch({ type: "FETCH_PRODUCTS_SUCCESS", payload });
    } catch (error) {
      dispatch({ type: "FETCH_PRODUCTS_FAILURE", payload: error.message });
    }
  };
};
